"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maskPhoneNumber = void 0;
const maskPhoneNumber = (countryCode = '', phoneNumber = '') => {
    if (phoneNumber.length <= 0) {
        return '';
    }
    const numberWithoutSpaces = phoneNumber.replaceAll(/\s+/g, '');
    const visibleEnd = numberWithoutSpaces.slice(-2);
    const maskedPart = numberWithoutSpaces.slice(0, -2).replaceAll(/\d/g, '*');
    const maskedNumber = countryCode + maskedPart + visibleEnd;
    return maskedNumber;
};
exports.maskPhoneNumber = maskPhoneNumber;
